import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { DownIcon } from 'components/Icons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import GradingListScalesItem from './ListItem'
import TableHeadCell from 'components/TableHeadCell'
import { hasFullPermission } from 'store'

export default function GradingListScales({ list, expanded, handleChange }) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const basePath = '/settings/grading/scales'

  if (!list) return null

  const actives = list.filter(item => item.enabled === true)
  const inactives = list.filter(item => item.enabled === false)
  const hasReadAndWritePermission = hasFullPermission('setting.grading')

  return (
    <Box>
      <Paper elevation={0} sx={{ mt: '5px' }}>
        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
          <AccordionSummary expandIcon={<DownIcon />}>
            <Typography>{t('Active Grading Scales')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {hasReadAndWritePermission && (
              <Stack flexDirection={'row'} alignItems={'flex-end'} justifyContent={'flex-end'}>
                <Button onClick={() => navigate(`${basePath}/new`)} size="small" variant="contained" color="primary">
                  {t('Add')}
                </Button>
              </Stack>
            )}

            <Table>
              <TableHead>
                <TableRow>
                  <TableHeadCell sx={{ width: '90%' }}>{t('Name')}</TableHeadCell>
                  <TableHeadCell sx={{ width: '10%' }}>{t('Action')}</TableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {actives && actives?.map((scale, index) => <GradingListScalesItem key={index} gradeScale={scale} />)}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </Paper>
      <Paper elevation={0} sx={{ mt: '5px' }}>
        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
          <AccordionSummary expandIcon={<DownIcon />}>
            <Typography>{t('Inactive Grading Scales')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeadCell sx={{ width: '90%' }}>{t('Name')}</TableHeadCell>
                  <TableHeadCell sx={{ width: '10%' }}>{t('Action')}</TableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inactives &&
                  inactives?.map((scale, index) => <GradingListScalesItem key={index} gradeScale={scale} />)}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Box>
  )
}
